<template>
  <svg
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_217_1955)">
      <path
        d="M15.4995 21.5018C11.3434 21.5018 8.05414 20.3179 5.72296 17.983C2.28878 14.5433 2.25673 9.88557 2.25702 9.68895C2.25802 9.08137 2.75082 8.58936 3.35841 8.58936H27.6954C28.3037 8.58936 28.7968 9.08245 28.7968 9.69074C28.7968 9.81197 28.7779 12.6931 27.128 15.5905C26.146 17.3153 24.7931 18.6903 23.1067 19.6775C21.039 20.8881 18.4795 21.5018 15.4995 21.5018ZM4.56702 10.7921C4.71295 11.7388 5.0573 13.1691 5.86941 14.5753C7.67964 17.7098 10.9196 19.2991 15.4995 19.2991C20.1326 19.2991 23.4009 17.6846 25.2139 14.5006C26.0069 13.1078 26.3444 11.7172 26.4879 10.7921H4.56702Z"
        fill="currentColor"
      />
      <path
        d="M6.9777 28.4525C6.82045 28.4524 6.66506 28.4185 6.52204 28.3532C5.96845 28.1012 5.72394 27.4481 5.97595 26.8945L9.14027 19.9432C9.39229 19.3896 10.0454 19.1451 10.599 19.3971C11.1526 19.6491 11.3971 20.3022 11.1451 20.8558L7.98079 27.8071C7.7961 28.2127 7.39609 28.4525 6.9777 28.4525Z"
        fill="currentColor"
      />
      <path
        d="M15.527 28.4522H6.97834C6.37005 28.4522 5.87695 27.9591 5.87695 27.3508C5.87695 26.7425 6.37008 26.2494 6.97834 26.2494H15.527C16.1353 26.2494 16.6284 26.7425 16.6284 27.3508C16.6284 27.9591 16.1353 28.4522 15.527 28.4522ZM24.0763 28.4376C23.658 28.4376 23.258 28.1979 23.0733 27.7923L19.909 20.8417C19.6569 20.2881 19.9014 19.635 20.455 19.383C21.0085 19.1309 21.6617 19.3754 21.9137 19.929L25.0781 26.8796C25.3302 27.4332 25.0857 28.0863 24.5321 28.3384C24.389 28.4037 24.2336 28.4376 24.0763 28.4376Z"
        fill="currentColor"
      />
      <path
        d="M24.0757 28.4374H15.527C14.9187 28.4374 14.4256 27.9443 14.4256 27.336C14.4256 26.7277 14.9188 26.2346 15.527 26.2346H24.0757C24.684 26.2346 25.1771 26.7277 25.1771 27.336C25.1771 27.9443 24.684 28.4374 24.0757 28.4374ZM11.2046 10.7881C11.0953 10.7881 10.9841 10.7717 10.8743 10.7373C10.294 10.5551 9.97125 9.93686 10.1535 9.35652L12.3447 2.37818C12.5269 1.79781 13.145 1.4751 13.7254 1.65733C14.3058 1.83955 14.6285 2.45775 14.4463 3.03809L12.2551 10.0164C12.1073 10.4869 11.673 10.7881 11.2046 10.7881Z"
        fill="currentColor"
      />
      <path
        d="M15.4788 3.80922H13.3955C12.7872 3.80922 12.2941 3.31609 12.2941 2.70783C12.2941 2.09957 12.7873 1.60645 13.3955 1.60645H15.4788C16.0871 1.60645 16.5802 2.09957 16.5802 2.70783C16.5802 3.31609 16.0871 3.80922 15.4788 3.80922Z"
        fill="currentColor"
      />
      <path
        d="M19.8492 10.7882C19.3808 10.7882 18.9465 10.487 18.7988 10.0164L16.6076 3.0381C16.4254 2.45776 16.7481 1.83956 17.3284 1.65734C17.9088 1.47508 18.5269 1.79784 18.7092 2.37819L20.9003 9.35652C21.0826 9.93687 20.7598 10.5551 20.1795 10.7373C20.0726 10.771 19.9613 10.7881 19.8492 10.7882Z"
        fill="currentColor"
      />
      <path
        d="M17.6584 3.80922H15.5756C14.9673 3.80922 14.4743 3.31609 14.4743 2.70783C14.4743 2.09957 14.9674 1.60645 15.5756 1.60645H17.6584C18.2667 1.60645 18.7598 2.09957 18.7598 2.70783C18.7598 3.31609 18.2667 3.80922 17.6584 3.80922ZM4.1215 16.6518C2.83399 16.6518 1.62274 15.8566 1.15771 14.5787C0.870071 13.7878 0.907454 12.9324 1.26291 12.1698C1.61861 11.4068 2.25013 10.8283 3.04112 10.5408C3.61287 10.3329 4.24472 10.628 4.45249 11.1997C4.6603 11.7714 4.36528 12.4033 3.79361 12.6111C3.55604 12.6974 3.36634 12.8712 3.25944 13.1005C3.15244 13.3301 3.14119 13.5875 3.22777 13.8256C3.40636 14.3163 3.95143 14.5704 4.44259 14.3917C5.01429 14.1837 5.64619 14.4786 5.85414 15.0502C6.06206 15.6219 5.76722 16.2538 5.19558 16.4617C4.8412 16.5906 4.47839 16.6518 4.1215 16.6518ZM26.8812 16.6517C26.5243 16.6517 26.1618 16.5906 25.8076 16.4617C25.2359 16.2538 24.9411 15.6219 25.149 15.0502C25.3569 14.4786 25.989 14.1837 26.5606 14.3917C27.0517 14.5703 27.5966 14.3161 27.7756 13.8251C27.9539 13.3344 27.7 12.7895 27.2092 12.6111C26.6375 12.4032 26.3426 11.7713 26.5505 11.1996C26.7583 10.6279 27.3902 10.333 27.9619 10.5409C29.5941 11.1343 30.4391 12.9456 29.8456 14.5784C29.3799 15.8565 28.1684 16.6517 26.8812 16.6517Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_217_1955">
        <rect
          width="30"
          height="30"
          fill="currentColor"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Hotpot',
} as DefineComponent
</script>
